import { css } from '@emotion/core'
import { measures } from 'styles/variables'

const { unit, half } = measures

export const buttonContent = css`
  transition: padding-right 300s;
`

export const submission = css`
  padding-right: ${unit + half}px;
`

export const loader = css`
  transform: scale(0.5);
  white-space: nowrap;
`
